import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('arize'),
  avatarPath: avatars.arize,
  logoPath: logos.arize
});
